import React from 'react'
import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import Link from 'components/Link'

const getFont = props => props.theme.secondaryFont

const getLinkColor = props => props.theme.link.secondary
const getLinkHoverColor = props => props.theme.link.secondaryHover || 'initial'

const getFontSize = props => getFont(props).mobile.size
const getPortraitFontSize = props => getFont(props).portrait.backlink || getFont(props).portrait.size

const getLineHeight = props => getFont(props).mobile.height
const getPortraitLineHeight = props => getFont(props).portrait.height

const StyledLoginLink = styled(Link)`
  color: ${getLinkColor};
  font-size: ${getFontSize};
  line-height: ${getLineHeight};

  &:hover {
    color: ${getLinkHoverColor};
  }

  ${breakpoint('portrait')`
    font-size: ${getPortraitFontSize};
    line-height: ${getPortraitLineHeight};
  `};
`

const getMargin = props => props.theme.registerPage.backLinkMargin.default
const getPortraitMargin = props => props.theme.registerPage.backLinkMargin.portrait

const LoginLinkView = styled.div`
  width: 100%;
  margin: ${getMargin};

  ${breakpoint('portrait')`
    margin: ${getPortraitMargin};
  `};
`

const LoginLink = ({children, className, ...props}) => (
  <LoginLinkView className={className}>
    <StyledLoginLink {...props}>{children}</StyledLoginLink>
  </LoginLinkView>
)

export default LoginLink
